import API_URL from '../apiconfig';
import { CatalogProduct, Vocabulary } from '../types/catalog';
import axios from './api';
import client from '../utils/react-query/client';

export async function getCatalog(businessId: string) {
  try {
    const response = await axios.get(`${API_URL}/v1/products`, {
      params: { businessId },
    });
    return response.data.result as CatalogProduct[];
  } catch (error) {
    throw new Error('Failed to get catalog', { cause: error });
  }
}

export async function getVocabulary(businessId: string) {
  try {
    const response = await axios.get(`${API_URL}/v1/attributes`, {
      params: { businessId },
    });
    return response.data.result as Vocabulary;
  } catch (error) {
    throw new Error('Failed to get vocabulary', { cause: error });
  }
}

export async function invalidateCatalog() {
  await client.invalidateQueries({ queryKey: ['catalog'], exact: false });
  await client.invalidateQueries({ queryKey: ['retail-items'], exact: false });
  await client.invalidateQueries({
    queryKey: ['catalog-vocabulary'],
    exact: false,
  });
}
